import {
    DrugCreationParams,
    DrugUpdateParams,
    DrugListResponse,
    DrugResponse,
    DrugListQuery,
    DrugHistoryQuery,
    DrugData,
    DrugStatus,
    DrugHistoryData,
    DrugHistoryListResponse,
    DrugStatusChangingForm,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/drug';

interface DrugStatusParams extends Omit<DrugStatusChangingForm, 'status'> {
    status?: DrugStatus;
}

export class DrugApi {
    /**
     * Возвращает созданный drug, если бэкенд отдаёт его в теле ответа.
     * Если тело пустое (старая версия бэка) — `undefined`; вызывающий код должен сделать fallback на `getList`.
     */
    public static async create(drug: DrugCreationParams): Promise<DrugData | undefined> {
        const res = await axios.post<DrugResponse | ''>(BASE_URL, { drug });

        return typeof res.data === 'object' ? res.data.drug : undefined;
    }

    public static async update(id: string, drug: DrugUpdateParams): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, { drug });
    }

    public static async remove(
        id: string,
        { status = DrugStatus.Cancelled, ...props }: DrugStatusParams,
    ): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/status`, { status, ...props });
    }

    public static async getList(params: DrugListQuery): Promise<DrugData[]> {
        const res = await axios.get<DrugListResponse>(BASE_URL, { params });

        return res.data.drugs;
    }

    public static async getDrug(id: string): Promise<DrugData> {
        const res = await axios.get<DrugResponse>(`${BASE_URL}/${id}`);

        return res.data.drug;
    }

    public static async getDrugHistory(params: DrugHistoryQuery): Promise<DrugHistoryData[]> {
        const res = await axios.get<DrugHistoryListResponse>(`${BASE_URL}/history`, { params });

        return res.data.drugs;
    }
}
